module.exports = new __parcel__URL__("TetherGoldLogo.5d02ace7.svg").toString();